/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable */
import './activityBookingTab.css';
import 'react-dates/lib/css/_datepicker.css';

import { useContext, useEffect, useMemo, useRef, useState } from 'react';

import { BookingDataContext } from '../../../context/BookingDataContext.jsx';
import { ReactComponent as Chevron } from '../../../assets/icons/trvto_downArrow.svg';
import { ReactComponent as Phone } from '../../../assets/icons/trvto_phone.svg';
import { ReactComponent as Message } from '../../../assets/icons/trvto_message.svg';
import { Navigate, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import moment from 'moment';
import tripBookingClick, {
    handleActUpdateNow,
    handleCustomTripBooking,
    handleUpdateNow
} from './activityBookingTabFun/activityBookingClick.js';
import { toast } from 'react-toastify';
import {
    calculateDisplayedPrice,
    calculateOfferPrice,
    getHikedPrice,
    getTaxAmount
} from '../../../utils/getAmountWithTransaction.js';
import { comfortableOptions, vehicleModes } from './activityBookingTabFun/constants/ActivityBookingConstant.js';
import { updateUserBookingDateAndPickupLocation } from '../../../api/userAPI.js';
import { ActivitiesBookingTab } from './activityBookingTabFun/bookingTab/ActivitiesBookingTab.jsx';
import { fetchTripDate } from '../activityDetailsFun/fetchTripData.js';

export default function ActivityBookingTab({
    packData,
    packDates,
    setPackDates,
    setLoading,
    isExpanded,
    setIsExpanded,
    // v2 passes its own review page
    reviewPath
}) {
    const { bookingData, setBookingData } = useContext(BookingDataContext);
    const [searchParams] = useSearchParams();
    const guestsParam = searchParams.get('guests');
    const [index, setIndex] = useState(0);
    const bookingTabRef = useRef(null);
    const naviagte = useNavigate();
    const numPeople = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const [timeSlots, setTimeSlots] = useState([]);
    const [isReserveChecked, setIsReserveChecked] = useState(false);
    // const [isInstallmentChecked, setIsInstallmentChecked] = useState(false);
    const [booking, setBooking] = useState(() => ({
        packDateId: '',
        people: bookingData?.people || 1,
        date: bookingData?.date || null,
        timeSlots: bookingData?.time || '',
        totalSeats: bookingData.totalSeats || [],
        meetupLocation: bookingData.meetupLocation || {},
        isReserved: false,
        amountPaid: {
            actual: 0,
            tax: 0,
            total: 0,
            isReserved: false,
            isInstallment: false,
            reserve: packData.price[0]?.reserve
        }
    }));
    const [reviewPage, setReviewPage] = useState(false);
    const [offerData, setOfferData] = useState({});
    const [focused, setFocused] = useState(false);
    const formatDate = (date) => {
        return new Date(date).toISOString().split('T')[0];
    };

    useEffect(() => {
        if (!booking?.date) return;

        const getTripDate = async () => {
            const dateOnly = moment(booking.date).format('YYYY-MM-DD');

            const tripDate = await fetchTripDate({ date: dateOnly, contentId: packData._id });
            const availableSlots = tripDate?.slots.filter(
                (slot) => slot.availableSlots > 0 && slot.totalSlots - slot.bookedSlots > 0
            );
            setBooking((prev) => ({
                ...prev,
                actDatesId: tripDate?._id || ''
            }));

            setTimeSlots(availableSlots || []);
        };

        getTripDate();
    }, [booking.date]);

    useEffect(() => {
        const interval = setInterval(() => {
            const input = document.querySelector('input.DateInput_input');
            if (input && !input.readOnly) {
                input.setAttribute('readonly', true);
                clearInterval(interval);
            }
        }, 50);
        return () => clearInterval(interval);
    }, [focused]);

    const confirmedBookingData = useMemo(() => {
        const data = sessionStorage.getItem('confirmedBookingData');
        return data ? JSON.parse(data) : null;
    }, []);

    useEffect(() => {
        if (!confirmedBookingData) return;

        setBooking((prev) => ({
            ...prev,

            actDatesId: confirmedBookingData.actDatesId || prev.actDatesId,

            date: confirmedBookingData.startDate || prev.date,

            timeSlots: confirmedBookingData.timeSlots || confirmedBookingData.time || prev.timeSlots,

            totalSeats: confirmedBookingData.totalSeats || prev.totalSeats,

            meetupLocation: confirmedBookingData.meetupLocation || prev.meetupLocation,

            amountPaid: {
                ...prev.amountPaid,
                ...(confirmedBookingData.amountPaid || {})
            }
        }));
    }, [confirmedBookingData]);
    useEffect(() => {
        if (Object.keys(bookingData).length !== 0) {
            setIsReserveChecked(bookingData?.amountPaid?.isReserved);
            setBooking({
                ...bookingData
            });
        }
    }, [bookingData]);

    const toggleExpand = () => {
        setIsExpanded((prev) => {
            const next = !prev;

            if (!prev) {
                setTimeout(() => {
                    bookingTabRef.current?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 150);
            }

            return next;
        });
    };

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsReserveChecked(checked);
        handleReservePay(checked);
    };

    const handleReservePay = (checked) => {
        setBooking((prev) => ({
            ...prev,
            amountPaid: {
                ...prev.amountPaid,
                isReserved: checked
            }
        }));
    };
    // const priceDetails = useMemo(() => {
    //     const actualhikePrice = Math.floor(getHikedPrice(packData.price[0].actual));
    //     const subTotal = Math.floor(actualhikePrice * booking.people);
    //     const discount = Math.floor(subTotal * 0.2);
    //     const actual = subTotal - discount;
    //     const tax = Math.floor(actual * 0.05);
    //     const total = actual + tax;

    //     return { actualhikePrice, subTotal, discount, actual, total, tax };
    // }, [booking.people, booking.amountPaid.actual]);

    const priceDetails = useMemo(() => {
        const seats = booking?.totalSeats || [];

        // Original subtotal
        const subTotal = seats.reduce((sum, item) => {
            const price = Math.floor(getHikedPrice(item.actual));
            return sum + price * item.qty;
        }, 0);

        // Calculate final price exactly the same way as traveller modal:
        // Math.floor(price * 80%)
        const actual = seats.reduce((sum, item) => {
            const price = Math.floor(getHikedPrice(item.actual));
            const discountedPrice = Math.floor(price * 0.8);

            return sum + discountedPrice * item.qty;
        }, 0);

        // Discount is the actual difference
        const discount = subTotal - actual;

        const tax = Math.round(actual * 0.05);
        const total = actual + tax;

        return {
            subTotal,
            discount,
            actual,
            tax,
            total
        };
    }, [booking?.totalSeats]);
    // useEffect(() => {
    //     localStorage.setItem('reserve', reserve);
    // }, [reserve]);

    if (reviewPage) {
        return <Navigate to={reviewPath || '/act/review-booking'} />;
    }

    return (
        <div
            ref={bookingTabRef}
            className={`tripBookingTab activityBookingWrapper ${isExpanded ? 'expanded' : 'collapsed'}`}
        >
            <div className={`tripBookingPriceDiv ${isExpanded ? 'expanded' : 'collapsed'}`}>
                <div className='toggleOverlay' onClick={toggleExpand} />
                <div>
                    <p className='tripBookingActualPrice'>
                        Rs.{Math.round(getHikedPrice(packData?.price[index].actual))}
                    </p>
                    <p className='tripBookingOffer'>{20}% OFF</p>
                    <p className='tripBookingPrice'>Rs. {Math.round(packData?.price[index]?.actual)} /person</p>
                    <p className='tripBookingTaxInc'>Excluding all taxes</p>
                </div>
                <div className='tripBookingChevronWrapper'>
                    <button onClick={toggleExpand} className='collapseArrow'>
                        <Chevron width={24} height={24} />
                    </button>
                    {/* {isExpanded === true && (
                               <> */}
                    {confirmedBookingData ? (
                        <button
                            className='tripButton tripBookingButton'
                            onClick={() =>
                                handleActUpdateNow({
                                    booking,
                                    confirmedBookingData,
                                    updateUserBookingDateAndPickupLocation,
                                    naviagte
                                })
                            }
                        >
                            Update Now
                        </button>
                    ) : (
                        <button
                            className='tripButton tripBookingSmallButton'
                            onClick={() =>
                                tripBookingClick(
                                    booking,
                                    setBookingData,
                                    setReviewPage,
                                    packData,
                                    amount,
                                    setLoading,
                                    packDates
                                )
                            }
                        >
                            Select Date
                        </button>
                        //     )}
                        // </>
                    )}
                </div>
            </div>
            <div className='tripBookingSubTab'>
                <div className='tripBookDataInput'>
                    {/* {!confirmedBookingData && packData?.price[0]?.reserve !== 0 && (
                        <div className='reserve-card'>
                            <input
                                type='checkbox'
                                id='reserve'
                                checked={isReserveChecked}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor='reserve' className='reserve-content'>
                                <div className='reserve-row'>
                                    <span className='reserve-title'>
                                        Reserve at Rs.{' '}
                                        {booking?.reserveTotal
                                            ? Math.round(booking.reserveTotal)
                                            : Math.round(packData?.price?.[0]?.reserve || 0)}
                                        {!booking?.reserveTotal && ' / person'}
                                    </span>
                                </div>
                                <div className='reserve-subtitle'>Pay the remaining amount on the trip</div>
                            </label>
                        </div>
                    )} */}
                    <ActivitiesBookingTab
                        booking={booking}
                        setBooking={setBooking}
                        confirmedBookingData={confirmedBookingData}
                        numPeople={numPeople}
                        time={timeSlots}
                        price={packData.price}
                        meetupLocation={packData.meetupLocation}
                        packData={packData}
                    />

                    {/* <label className='tripBookDatalabel2'>Offer Code</label>
            <div className='tripBookOfferDiv'>
                <input
                    type='text'
                    placeholder='Enter promo code'
                    name='offerCode'
                    value={offerCode}
                    className='tripBookOfferIn'
                    onChange={(e) => handlePromoCode(e)}
                />
                <button
                    className='tripBookOfferBtn'
                    onClick={() => offerApplyTrip(offerCode, setOfferData, setBooking, booking, amount)}
                >
                    Apply
                </button>
            </div>  */}
                </div>
                {priceDetails?.subTotal > 0 &&
                    (booking.amountPaid?.isReserved ? (
                        <>
                            <div className='tripPriceCal'>
                                <p className='tripBookPrice'>Reserve Price</p>
                                <p className='tripBookPrice'>₹{booking?.reserveTotal}</p>
                            </div>

                            <div className='tripBookTotalDiv'>
                                <p className='tripBookTotalText'>Total:</p>
                                <p className='tripBookTotalText'>₹{booking?.reserveTotal}</p>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className='tripPriceCal'>
                                <p className='tripBookPrice'>₹{priceDetails.subTotal}</p>
                                <p className='tripBookPrice'>₹{priceDetails.subTotal}</p>
                            </div>

                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>Discount</p>
                                <p className='tripBookOfferText'>- ₹{priceDetails.discount}</p>
                            </div>

                            {Object.keys(offerData).length !== 0 && (
                                <div className='tripBookOfferDiv'>
                                    <p className='tripBookOfferText'>Offer</p>
                                    <p className='tripBookOfferText'>- ₹{booking?.amountPaid?.offerAmo}</p>
                                </div>
                            )}

                            <div className='tripBookTotalDiv'>
                                <p className='tripBookTotalText'>Total:</p>
                                <p className='tripBookTotalText'>₹{priceDetails.actual}</p>
                            </div>
                        </>
                    ))}
                <div className='tripBookBtnDiv'>
                    {confirmedBookingData ? (
                        <button
                            className='tripButton tripBookingButton'
                            onClick={() =>
                                handleActUpdateNow({
                                    booking,
                                    confirmedBookingData,
                                    updateUserBookingDateAndPickupLocation,
                                    naviagte
                                })
                            }
                        >
                            Update Now
                        </button>
                    ) : (
                        <button
                            className='tripButton tripBookingButton'
                            onClick={() =>
                                tripBookingClick(
                                    booking,
                                    setBookingData,
                                    setReviewPage,
                                    packData,
                                    setLoading,
                                    priceDetails
                                )
                            }
                        >
                            Book Now
                        </button>
                    )}
                </div>
                <div className='helpSection'>
                    <div>Need Help?</div>
                    <div className='helpContact'>
                        <a href='tel:+918088788874' className='callBtn'>
                            <Phone width={20} height={20} />
                            Call
                        </a>
                        <a
                            className='chatBtn'
                            href={`https://wa.me/918088788874`}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            <Message width={22} height={22} fill='black' />
                            Chat
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
